module.exports = __webpack_public_path__ + "static/media/blackseo.c5bd6b37.jpg";